import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";
import PageLayout from '../../components/layout/PageLayout';
import DataTable from '../../components/ui/DataTable';
import { notify } from '../../components/feedback/notify';
import { FormatDate } from "../../utils/FormatDate";
import { MascaraTelefone } from "../../utils/MascaraTelefone";

function DescontosUsados() {
    const { idDesconto } = useParams();

    const token = localStorage.getItem('token');
    const [descontosUsados, setDescontosUsados] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getDescontosUsados = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/getDescontosUsados/${idDesconto}`, {
                    headers: {
                        Authorization: token
                    }
                });
                setDescontosUsados(response.data.descontosUsados || []);
            } catch (error) {
                console.error("Erro ao buscar descontos usados:", error);
                notify.error("Não foi possível carregar os usos deste desconto.");
            } finally {
                setLoading(false);
            }
        }
        getDescontosUsados();
    }, [idDesconto, token])

    const codigo = descontosUsados[0]?.desconto?.discountCode;

    const columns = [
        { key: 'idDesconto', label: 'ID', width: 72, render: (d) => d?.idDesconto },
        { key: 'nome', label: 'Cliente', sx: { fontWeight: 500 }, render: (d) => d?.usuario?.Nome || '—' },
        { key: 'email', label: 'E-mail', render: (d) => d?.usuario?.Email || '—' },
        { key: 'telefone', label: 'Telefone', render: (d) => MascaraTelefone(d?.usuario?.Telefone) || '—' },
        { key: 'codigo', label: 'Código', render: (d) => d?.desconto?.discountCode || '—' },
        { key: 'valor', label: 'Desconto', render: (d) => `${d?.desconto?.valorDesconto ?? 0}%` },
        { key: 'usadoEm', label: 'Usado em', render: (d) => (d?.updatedAt ? FormatDate(d.updatedAt) : '—') },
    ];

    return (
        <PageLayout
            title="Uso do desconto"
            subtitle={codigo ? `Clientes que utilizaram o código ${codigo}.` : 'Clientes que utilizaram este código de desconto.'}
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Descontos', to: '/descontos' }, { label: 'Uso do desconto' }]}
        >
            <DataTable
                columns={columns}
                rows={descontosUsados}
                getRowKey={(d, i) => `${d?.idDesconto}-${d?.usuario?.idUsuario ?? i}-${i}`}
                loading={loading}
                emptyMessage="Nenhum cliente usou esse código de desconto."
            />
        </PageLayout>
    );
}

export default DescontosUsados;
